import type { Theme as ThemeBase } from '@mui/material';
// eslint-disable-next-line no-restricted-imports -- this file is the hooks/useTheme wrapper the rule points to; the @mui/material root would load every MUI component
import { useTheme as useThemeBase } from '@mui/material/styles';

import type { Neutral } from '@savvy/deprecated-shared/theme';

// Declare our own theme properties
export type Theme = Omit<ThemeBase, 'palette'> & {
  palette: ThemeBase['palette'] & {
    background: {
      contrast: string;
    };
    neutral: Neutral;
    text: {
      charcoal: string;
      primary: string;
      secondary: string;
    };
    info: {
      alertBackground: string;
      alertContent: string;
    };
  };
};

export function useTheme(): Theme {
  const theme = useThemeBase<Theme>();
  return theme;
}
